module.exports = {
	"articleTitle1": "Blue Nile cooks up fine cuisine",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Blue Nile",
	"articleLink1": "https://www.michigandaily.com/content/blue-nile-cooks-fine-cuisine",
	"articleLink2": "https://www.michigandaily.com/arts/1food-column24",
	"articleSnippet1": "Mar 17, 2005 ... Beth Dykstra: Patrons of The Blue Nile on East Washington Street use thin, \nspongy injera bread to scoop up food served in one community ...",
	"articleSnippet2": "Jan 24, 2013 ... You see, the Blue Nile is certainly not the best restaurant in Ann Arbor, but for \nmost people, it offers a completely new dining experience. My first ...",
	"foodRecommendations": [
		{
			"text": "Ethiopian cuisine, which you never knew you needed",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Nathan Wood: Serving up the 'musts and busts' of restaurant week",
	"address": "221 E. Washington Street, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280523,
		"lng": -83.746322
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bluenile.json
// module id = 834
// module chunks = 0